import styled from '@app/styled';

export const Icons = styled.div`
    display: flex;
    justify-content: space-between;
    width: 230px;
    margin: 0 auto 10px;
    align-items: center;
`;

export const Header = styled.h4`
    margin-bottom: 30px;
`;
